<div class="body-container-wrapper">
  <section class="retirement-home-page-banner p-0">
      <div class="container-fluid" style=" margin-bottom: 10px;">
          <div class="row align-items-start">
              <div class="col-md-8 col-sm-12">
                  <figure>
                      <img src="../../../assets/images/wish-sip/Wish-Karo-Sip-Karo-Landing-page1.webp" alt="" class="banner-img">
                  </figure>
              </div>
              <!-- Form Section -->
              <div class="col-md-4 col-sm-12">
                  <div class="card banner-form">
                      <div class="card-body success-card">
                          <div class="success-tick">
                              <h2 style="color: black;">Thank you!</h2>
                          </div>
                          <h6>A member of our care team will get in touch with you shortly.</h6>
                      </div>
                  </div>
              </div>
              <!-- old form end  -->
          </div>
      </div>
  </section>
  <section class="second-section" id="mobilebanner" style="display: none">
      <img src="../../../assets/images/wish-sip/Wish-Karo-Sip-Karo-Landing-page1.webp" alt="mobile banner" width="1383" height="550" loading="eager" rel="preload" as="image">
  </section>
 
  
  <section class="section-1" style="background-color: white;">
      <div class="container" style="background-color: white;">
  <img src="../../../assets/images/wish-sip/wishkaro1.png" alt="">
          <h2>WISH A SIP</h2>
    <h4 style="text-align: center; color: #ED1B24; font-size: 1.6em; margin: 0px;">For Each Life Goal</h4>
          <div class="grid-container">
              <div class="box">
                  <img src="../../../assets/images/wish-sip/child education.png" alt="">
                  <div class="box-content">
                      <h3>Children Future Planning</h3>
                      <p>Initiate a SIP for your Kid’s Higher Education</p>
                  </div>
              </div>
              <div class="box">
                 <img src="../../../assets/images/wish-sip/child marriage.png" alt="">
                  <div class="box-content">
                      <h3>Children Marriage</h3>
                      <p>Start a SIP for your kid’s lavish wedding</p>
                  </div>
              </div>
              <div class="box">
                  <img src="../../../assets/images/wish-sip/dream home car.png" alt="">
                  <div class="box-content">
                      <h3>Dream Home and Car</h3>
                      <p>Begin a SIP to contribute for Dream Home and Car</p>
                  </div>
              </div>
              <div class="box">
                  <img src="../../../assets/images/wish-sip/travell.png" alt="">
                  <div class="box-content">
                      <h3>Travel & Leisure</h3>
                      <p>Holiday Carefree with Adequate Funds for each aspect</p>
                  </div>
              </div>
              <div class="box">
                  <img src="../../../assets/images/wish-sip/retirement.png" alt="">
                  <div class="box-content">
                      <h3>Retirement</h3>
                      <p>Enjoy Retirement with Financial security backing you</p>
                  </div>
              </div>
          </div>
      </div>
  </section>

       <section class="section-2">
      <div class="container">
          <h2 style="color: #ED1B24;">Your SIP Journey</h2>
          <div class="grid-container">
              <div class="process-box">
                   <img src="../../../assets/images/wish-sip/image7.png" alt="">
                  <p>Understand your Life goals</p>
              </div>
              <div class="process-box" >
                <img src="../../../assets/images/wish-sip/image9.png" alt="">
                  <p>Start a <span style="color: red; font-weight: 700;">SIP Today</span> to achieve each one of it</p>
              </div>
              <div class="process-box" >
                  <img src="../../../assets/images/wish-sip/image8.png" alt="">
                  <p>Accomplish Goals as per their set Horizon</p>
              </div>
          </div>
      </div>
  </section>

      <section class="section-3" style="background-color: white;">
      <div class="container" style="margin-top: 34px;" style="background-color: white;">
          <h2>Why Mutual Funds</h2>
    <h5 style="margin-top: 20px;">are important for every Investor for achieving financial goals?</h5>
          <div class="grid-container">
              <div class="column-item">
                  <img src="../../../assets/images/wish-sip/image11.png" alt="">
                  <h3>Goal-Based Investing Made Easy</h3>
                  <p>
Whether it's saving for your child's education, buying a home, or planning retirement-mutual funds help match investments to timelines & risk profiles and SIPs automate this journey smartly.</p>
              </div>
              <div class="column-item">
                  <img src="../../../assets/images/wish-sip/image12.png" alt="">
                  <h3>Diversification with Low Entry Barriers</h3>
                  <p>
Even with small monthly amounts, mutual funds offer access to a diversified portfolio-across sectors, market caps, and geographies-reducing risk compared to direct stock investing.</p>
              </div>
              <div class="column-item">
                  <img src="../../../assets/images/wish-sip/image13.png" alt="">
                  <h3>Professionally Managed for Growth</h3>
                  <p>
They’re managed by SEBI-registered experts who make informed investment decisions, saving individuals from complex financial analysis</p>
              </div>
              <div class="column-item">
                  <img src="../../../assets/images/wish-sip/image14.png" alt="">
                  <h3>Liquidity & Flexibility</h3>
                  <p>
Needs funds for an emergency or a goal? Most mutual fund schemes offer easy redemption with minimal paperwork and tax-efficient options.</p>
              </div>
              <div class="column-item">
                  <img src="../../../assets/images/wish-sip/image15.png" alt="">
                  <h3>Regulated, Transparent & Safe</h3>
                  <p>
All mutual funds in India are strictly regulated by SEBI and AMFI, offering transparency in performance, costs, and risk levels.</p>
              </div>
              <div class="column-item">
                  <img src="../../../assets/images/wish-sip/image16.png" alt="">
                  <h3>Power of Compounding through SIPs</h3>
                  <p>
With regular SIPs, even modest amounts grow significantly over time-thanks to the magic of compounding and rupee cost averaging.</p>
              </div>
          </div>
      </div>
 <img src="../../../assets/images/wish-sip/WishKaroSIP.png" alt="">
  </section>


    









<section id="sipSection" class="financial-calculators"  *ngIf="currentCalculator === 'sip'" style="
  margin-top: 10px;
  background-color: white;
">
  <div class="container">
      <div class="row position-relative">
        <div class="col-xl-12 col-lg-12 col-md-12">
         
           <div class="left">
            <div class="calculator">
              <div class="sip">
                <div class="number">
                  <h1 class="heading">SIP Calculator</h1>
                   <div class="chips">
                <a class="badges active" style="cursor:pointer" (click)="showCalculator('sip')">SIP</a>
                <a class="badges"style="cursor:pointer" (click)="showCalculator('lumsum')">Lumpsum</a>
              </div>
                  <div class="calculators">
                    <div class="monthly">
                      <div class="month_heading">
                        <p class="text">Monthly investment</p>
                        <div class="tooltiped" id="error_msg">
                          <span class="material-icons-outlined icon"> info </span>
                          <span class="tooltiptext tooltip-top">{{
                            amount_errormsg
                          }}</span>
                        </div>
                        <div class="placeholder">
                          <i class="fa fa-inr" aria-hidden="true"></i>
                          <input
                            class="range__amount"
                            id="monthlyInput"
                            name="monthlyInput"
                            [(ngModel)]="Monthly_investment"
                            type="number"
                            value="25000"
                            min="500"
                            max="200000"
                            (input)="
                              setInvestmentValue($event);
                              preventInput($event);calculation();updateChartData(chartData)
                            "
                          />
                        </div>
                      </div>
                      <div class="month_range">
                       <div
                            class="calculator-range-slider calculator-custom-range"
                          >
                            <input
                              type="range"
                              name=""
                              step="500"
                              value="25000"
                              class="input-range calc-result-sliders"
                              min="500"
                              max="200000"
                               id="monthlyRange"
                              [(ngModel)]="Monthly_investment"
                              (input)="monthlyInvestmentRangeVal()"
                              (change)="calculation(); updateChartData(chartData)"
                            />
                            <span
                            class="type-range"
                            [style.width.%]="(P / 200000) * 100"
                          ></span>
                          <span
                            class="thumb thumbNew"
                            [style.left.%]="(P / 200000) * 100"
                          ></span>
                          </div>
                        <div class="values">
                          <p class="value">₹500</p>
                          <p class="value">₹2,00,000</p>
                        </div>
                      </div>


                
                    </div>
                    <div class="monthly">
                      <div class="month_heading">
                        <p class="text">Expected return rate (p.a)</p>
                        <div class="tooltiped" id="error_msg1">
                          <span class="material-icons-outlined icon"> info </span>
                          <span class="tooltiptext tooltip-top">{{
                            Expected_Rate_error
                          }}</span>
                        </div>
                        <div class="placeholder reverse">
                          <i class="percent">%</i>
                          <input
                            class="range__amount"
                            id="monthlyexpect"
                            type="number"
                            value="12"
                            min="1"
                            max="30"
                            [(ngModel)]="monthlyexpect"
                            (input)="
                              setRateValue($event);
                              preventInput($event);calculation();updateChartData(chartData)
                            "
                            
                          />
                        </div>
                      </div>
                      <div class="month_range">
                        <div
                          class="calculator-range-slider calculator-custom-range"
                        >
                          <input
                            type="range"
                            name=""
                            step="0.1"
                            class="input-range calc-result-sliders"
                            min="1"
                            max="30"
                            id="monthlyrate"
                            [(ngModel)]="monthlyexpect"
                            (input)="monthlyRateRangeVal()"
                            (change)="calculation(); updateChartData(chartData)"
                          />
                          <span
                            class="type-range"
                            [style.width.%]="(R / 30) * 100"
                          ></span>
                          <span
                            class="thumb thumbNew"
                            [style.left.%]="(R / 30) * 100"
                          ></span>
                        </div>
                        <div class="values">
                          <p class="value">1%</p>
                          <p class="value">30%</p>
                        </div>
                      </div>
                    </div>
                    <div class="monthly">
                      <div class="month_heading">
                        <p class="text">Time period</p>
                        <div class="tooltiped" id="error_msg2">
                          <span class="material-icons-outlined icon"> info </span>
                          <span class="tooltiptext tooltip-top">{{
                            Time_period_error
                          }}</span>
                        </div>
                        <div class="placeholder reverse">
                          <i class="year">Yr</i>
                          <input
                            class="range__amount"
                            id="timeperiod"
                            type="number"
                            value="10"
                            min="1"
                            max="30"
                            [(ngModel)]="timeperiod"
                            (input)="
                              setTimeValue($event);
                              preventInput($event);calculation();updateChartData(chartData)
                            "
                            
                          />
                        </div>
                      </div>
                      <div class="month_range">
                        <div
                          class="calculator-range-slider calculator-custom-range"
                        >
                          <input
                            type="range"
                            name=""
                            id="timerange"
                            step="1"
                            value="10"
                            class="input-range calc-result-sliders"
                            min="1"
                            max="30"
                            [(ngModel)]="timeperiod"
                            (input)="monthlyTimeRangeVal()"
                            (change)="calculation(); updateChartData(chartData)"
                          />
                          <span
                            class="type-range"
                            [style.width.%]="(T / 30) * 100"
                          ></span>
                          <span
                            class="thumb thumbNew"
                            [style.left.%]="(T / 30) * 100"
                          ></span>
                        </div>
                        <div class="values">
                          <p class="value">1Yr</p>
                          <p class="value">30Yr</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="data">
                  <div class="graph">
                    <ul class="indicators">
                      <li class="amount">Invested amount</li>
                      <li class="return">Est. returns</li>
                    </ul>
                    <div class="graph_img">
                      <canvas id="myChart" width="260px" height="150px"></canvas>
                      <!-- <img src="../../../assets/images/wish-sip/graph.png" class="img-fluid" alt="graph"> -->
                    </div>
                    <div class="values">
                      <ul class="list">
                        <li class="text">Invested amount:</li>
                        <li class="value">
                          ₹{{ total_investment_ammount | conversions }}
                        </li>
                        <li class="text">Est. returns:</li>
                        <li class="value">
                          ₹{{ estmated_return | conversions }}
                        </li>
                      </ul>
                      <ul class="list total">
                        <li class="text">Total value:</li>
                        <li class="value">
                          ₹{{ calculate_value | conversions }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="invest_btn">
                    <a (click)="scrolltop()" style="cursor: pointer;">
                          <img src="../../../assets/images/wish-sip/Connect-Now-Button.png" alt="Invest Now" style="height:80px;" />
                          </a>
                  </div>
                </div>
              </div>
              <!-- <div class="lumpsum"></div> -->
            </div>
          </div>
    
        </div>
      </div>
  </div>

</section>



<section class="financial-calculators" *ngIf="currentCalculator === 'lumsum'" style="
  margin-top: 10px;
  background-color: white;
">
  <div class="container">
      <div class="row position-relative">
        <div class="col-xl-12 col-lg-12 col-md-12">      
         <div class="left">
<div class="calculator">
              <div class="sip">
                <div class="number">
                  <h1 class="heading">Lumpsum Calculator</h1>
                   <div class="chips">
                <a class="badges" style="cursor:pointer" (click)="showCalculator('sip')">SIP</a>
                <a class="badges active" style="cursor:pointer" (click)="showCalculator('lumsum')">Lumpsum</a>
              </div>
                      <div class="calculators">
                    <div class="monthly">
                      <div class="month_heading">
                        <p class="text">Total investment</p>
                        <div class="tooltiped" id="error_msg">
                          <span class="material-icons-outlined icon"> info </span>
                          <span class="tooltiptext tooltip-top">{{
                            L_amount_errormsg
                          }}</span>
                        </div>
                        <div class="placeholder">
                          <i class="fa fa-inr" aria-hidden="true"></i>
                          <input
                            class="range__amount"
                            id="monthlyInput"
                            name="monthlyInput"
                            [(ngModel)]="L_Monthly_investment"
                            type="number"
                            value="25000"
                            min="500"
                            max="2000000"
                            (input)="
                              setInvestmentValue2($event);
                              preventInput($event);calculation2();updateChartData2(chartData)
                            "
                          />
                        </div>
                      </div>
                      <div class="month_range">
                       <div
                            class="calculator-range-slider calculator-custom-range"
                          >
                            <input
                              type="range"
                              name=""
                              step="500"
                              value="25000"
                              class="input-range calc-result-sliders"
                              min="500"
                              max="2000000"
                               id="monthlyRange"
                              [(ngModel)]="L_Monthly_investment"
                              (input)="monthlyInvestmentRangeVal2()"
                              (change)="calculation2(); updateChartData2(chartData)"
                            />
                            <span
                            class="type-range"
                            [style.width.%]="(LP / 2000000) * 100"
                          ></span>
                          <span
                            class="thumb thumbNew"
                            [style.left.%]="(LP / 2000000) * 100"
                          ></span>
                          </div>
                        <div class="values">
                          <p class="value">₹500</p>
                          <p class="value">₹20,00,000</p>
                        </div>
                      </div>


                
                    </div>
                    <div class="monthly">
                      <div class="month_heading">
                        <p class="text">Expected return rate (p.a)</p>
                        <div class="tooltiped" id="error_msg1">
                          <span class="material-icons-outlined icon"> info </span>
                          <span class="tooltiptext tooltip-top">{{
                            L_Expected_Rate_error
                          }}</span>
                        </div>
                        <div class="placeholder reverse">
                          <i class="percent">%</i>
                          <input
                            class="range__amount"
                            id="monthlyexpect"
                            type="number"
                            value="12"
                            min="1"
                            max="30"
                            [(ngModel)]="L_monthlyexpect"
                            (input)="
                              setRateValue2($event);
                              preventInput($event);calculation2();updateChartData2(chartData)
                            "
                            
                          />
                        </div>
                      </div>
                      <div class="month_range">
                        <div
                          class="calculator-range-slider calculator-custom-range"
                        >
                          <input
                            type="range"
                            name=""
                            step="0.1"
                            class="input-range calc-result-sliders"
                            min="1"
                            max="30"
                            id="monthlyrate"
                            [(ngModel)]="L_monthlyexpect"
                            (input)="monthlyRateRangeVal2()"
                            (change)="calculation2(); updateChartData2(chartData)"
                          />
                          <span
                            class="type-range"
                            [style.width.%]="(LR / 30) * 100"
                          ></span>
                          <span
                            class="thumb thumbNew"
                            [style.left.%]="(LR / 30) * 100"
                          ></span>
                        </div>
                        <div class="values">
                          <p class="value">1%</p>
                          <p class="value">30%</p>
                        </div>
                      </div>
                    </div>
                    <div class="monthly">
                      <div class="month_heading">
                        <p class="text">Time period</p>
                        <div class="tooltiped" id="error_msg2">
                          <span class="material-icons-outlined icon"> info </span>
                          <span class="tooltiptext tooltip-top">{{
                            L_Time_period_error
                          }}</span>
                        </div>
                        <div class="placeholder reverse">
                          <i class="year">Yr</i>
                          <input
                            class="range__amount"
                            id="timeperiod"
                            type="number"
                            value="10"
                            min="1"
                            max="30"
                            [(ngModel)]="L_timeperiod"
                            (input)="
                              setTimeValue2($event);
                              preventInput($event);calculation2();updateChartData2(chartData)
                            "
                            
                          />
                        </div>
                      </div>
                      <div class="month_range">
                        <div
                          class="calculator-range-slider calculator-custom-range"
                        >
                          <input
                            type="range"
                            name=""
                            id="timerange"
                            step="1"
                            value="10"
                            class="input-range calc-result-sliders"
                            min="1"
                            max="30"
                            [(ngModel)]="L_timeperiod"
                            (input)="monthlyTimeRangeVal2()"
                            (change)="calculation2(); updateChartData2(chartData)"
                          />
                          <span
                            class="type-range"
                            [style.width.%]="(LT / 30) * 100"
                          ></span>
                          <span
                            class="thumb thumbNew"
                            [style.left.%]="(LT / 30) * 100"
                          ></span>
                        </div>
                        <div class="values">
                          <p class="value">1Yr</p>
                          <p class="value">30Yr</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="data">
                  <div class="graph">
                    <ul class="indicators">
                      <li class="amount">Invested amount</li>
                      <li class="return">Est. returns</li>
                    </ul>
                    <div class="graph_img">
                      <canvas id="myChart" width="260px" height="150px"></canvas>
                      <!-- <img src="../../../assets/images/wish-sip/graph.png" class="img-fluid" alt="graph"> -->
                    </div>
                    <div class="values">
                      <ul class="list">
                        <li class="text">Invested amount:</li>
                        <li class="value">
                          ₹{{ L_total_investment_ammount | conversions }}
                        </li>
                        <li class="text">Est. returns:</li>
                        <li class="value">
                          ₹{{ L_estmated_return | conversions }}
                        </li>
                      </ul>
                      <ul class="list total">
                        <li class="text">Total value:</li>
                        <li class="value">
                          ₹{{ L_calculate_value | conversions }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="invest_btn">
                          <a (click)="scrolltop()" style="cursor: pointer;">
                          <img src="../../../assets/images/wish-sip/Connect-Now-Button.png" alt="Invest Now" style="height:80px;" />
                          </a>
                  </div>
                </div>
              </div>
              <!-- <div class="lumpsum"></div> -->
            </div>
          </div>
    
        </div>
      </div>
  </div>

</section>



<section class="download-section" style="
  background-color: #d00000">
  <h2 class="download-heading" style="
  color: white;margin-top: 48px;">START A SIP ON YOUR FINGERTIPS NOW.</h2>

  <div class="download-container">
      <div class="app-image">
          <img src="../../../assets/images/wish-sip/Wish Karo Sip Karo Landing page icon-11.png" alt="App Image" />
      </div>
      <div class="store-buttons">
          <a href="https://apps.apple.com/in/app/ameya/id6741098441" target="_blank">
              <img src="../../../assets/images/wish-sip/Wish Karo Sip Karo Landing page_icon-12.png" alt="App Store" />
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.bajajcapital.investments&hl=en_IN" target="_blank">
              <img src="../../../assets/images/wish-sip/Wish Karo Sip Karo Landing page_icon-13.png" alt="Google Play" />
          </a>
      </div>
  </div>
</section>




       <div class="new-section">
        <p>www.BajajCapital.com</p>
       </div>

  <div class="container">
      <p class="col-md-12 mt-3 terms"> <span style="font-weight: bold;">Disclaimer: </span>Bajaj Capital Limited (BCL) (CIN: U67120DL1965PLC004338) is a mutual fund distributor (ARN 0010) registered with AMFI. Registered Office: Mezzanine Floor, Bajaj House 97, Nehru Place, New Delhi-110019. Mutual Fund investments are subject to market risk, read all scheme-related documents carefully. Certain products and services offered by BCL may not be traded on the exchange. All disputes with respect to the distribution activity, would not have access to Exchange Investor Redressal Forum or Arbitration mechanism. In accordance with the applicable laws, BCL is allowed to render incidental advice with respect to mutual fund products only to its mutual fund distribution clients. For every other purpose, including distribution of non-mutual fund products, the circulated material is for informational purposes only. Further, it is not intended as investment advice or an opinion concerning securities or a public offer proving a basis for an investment decision. The views or expressions contained in the circulated material are not necessarily of BCL and BCL neither assumes any responsibility/liability nor does guarantee its accuracy, suitability, completeness and adequacy. The figures and data that may be appearing in the material are taken from various sources and BCL is not responsible for the accuracy of the same. The content of the material including images, charts, graphics and pictures are protected intellectual properties and cannot be amended, copied, reproduced, replicated, republished, uploaded, posted, published, transmitted, displayed or distributed for any non-personal use without obtaining prior written permission, any non-adherence of which may attract appropriate legal action. The past performance of the scheme is not indicative of future performance. Investors are advised to seek appropriate advice from experts before taking any investment decisions. Nothing in the circulated material is intended to construe an advertisement or an investment, financial advice and/or solicitation, advice to buy, sell or deal in any financial product.</p>
  </div>